import ContentCard from "./ContentCard"

export default function OneJournal({ data }) {
  return <ContentCard data={data} type="Journal" viewer="view-journal" />
}
